import { render } from "./ReferAndEarnVue.vue?vue&type=template&id=12cb50d0&scoped=true"
const script = {}

import "./ReferAndEarnVue.vue?vue&type=style&index=0&id=12cb50d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cb50d0"]])

export default __exports__